module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Space Grey Aluminum + Black Closed.335cbe68.png";